/* eslint-disable react/display-name */
import DomainsDetail from './DomainsDetailController'

export default DomainsDetail
